import { styled } from '@mui/material';
import { hexadecimal } from '../../utils/stringUtils.js';
import React from 'react';

var AnimationDotContainer = styled('div')(function (_a) {
    var size = _a.size, topOffset = _a.topOffset, rightOffset = _a.rightOffset, dotColor = _a.dotColor;
    return ({
        ':after': {
            animation: "shadow-pulse__RutlBg 4s infinite",
            backgroundColor: dotColor,
            borderRadius: '50%',
            content: '""',
            display: 'block',
            height: "".concat(size, "px"),
            width: "".concat(size, "px"),
            position: 'absolute',
            right: "".concat(rightOffset, "px"),
            top: "".concat(topOffset, "px"),
            '@keyframes  shadow-pulse__RutlBg': {
                '0%': { boxShadow: "0 0 0 0 ".concat(hexadecimal(dotColor)(50)) },
                '50%': { boxShadow: "0 0 0 0 ".concat(dotColor) },
                '100%': { boxShadow: "0 0 0 ".concat(size, "px transparent") },
            },
        },
    });
});
var AnimationDot = function (_a) {
    var animationDot = _a.animationDot, dotSize = _a.dotSize, topOffset = _a.topOffset, rightOffset = _a.rightOffset, dotColor = _a.dotColor;
    if (!animationDot)
        return null;
    return (React.createElement(AnimationDotContainer, { size: dotSize, topOffset: topOffset, rightOffset: rightOffset, dotColor: dotColor }));
};

export { AnimationDot };
//# sourceMappingURL=AnimationDot.js.map
